import { useMemo } from 'react'

import permissionService from '@app/services/permissionService'

import { useUserQuery } from '@app/hooks'

import type { usePermissionsParams } from './types'

export const useCheckPermissionAccess = ({ requiredRoles, requiredPermissions }: usePermissionsParams): boolean => {
  const { data: user } = useUserQuery()

  return useMemo(
    () => permissionService.checkAccess({ userRoles: user?.roles, requiredRoles, requiredPermissions }),
    [user]
  )
}
